module.exports = __webpack_public_path__ + "img/mock7.fdf2fb50.png";